import { Components, Theme } from '@mui/material/styles';

export const muiListOverride: Components<Theme>['MuiList'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
    }),
  },
};
